import { useLocation } from "react-router-dom"
import { PendingApprovalPage } from "../../modules/pending-approval"
 
interface PendingApprovalsProps {
  sidebarOpen?: boolean
}

export default function PendingApprovals({ sidebarOpen }: PendingApprovalsProps) {
  const location = useLocation()
  const activeTab = location.pathname.includes("/leave") ? "leave" : "timesheet"
  
  return <PendingApprovalPage activeTab={activeTab} />
}
